import { BaseInput, BaseTextArea } from "@/components/input/CustomInputs";
import { formInterface } from "@/interface/dataInterface";
import { FC } from "react";

const VendorForm: FC<formInterface> = ({formProp, setFormProp}) => {
    return (
        <div className="grid place-items-center gap-y-4 ">
            <BaseInput 
                id="vendor_name"
                label="Name"
                value={formProp.vendor_name}
                setProp={setFormProp}
            />
            <BaseTextArea 
                id="notes"
                label="Notes"
                value={formProp.notes}
                setProp={setFormProp}
            />
        </div>
    )
}

export default VendorForm